import { useEffect, useMemo, useState } from 'react';
import '/assets/styles/pages/web-menu.scss';

// Partials
import Loader from '/views/partials/loader';
import Link from '@wearetla/tla-essentials-tools/partials/link';
import Img from '@wearetla/tla-essentials-tools/partials/img';

// Sections
import WebMenuHeader from '/views/sections/web-menu-header';
import WebMenuLanding from '/views/sections/web-menu-landing';

// Services
import menuServices from '/services/menu';

// Context
import { useApplication } from '/utilities/application';
import { useBranchSelection } from '/utilities/branch-selection';
import { useNavigator, useParams } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';

const WebMenu = () => {
	const { isApplication } = useApplication();
	const { submitMenuUrl, initialized } = useBranchSelection();
	const { branchSlug } = useParams(['webMenu', 'webMenuDisplayed']);
	const { openModal } = useModals();
	const { redirect, activeRoute } = useNavigator();
	const [categories, setCategories] = useState(null);

	const displayMenu = useMemo(() => activeRoute?.key === 'webMenuDisplayed', [activeRoute]);

	useEffect(() => {
		if (!isApplication && branchSlug) {
			setCategories(null);
			menuServices
				.getMenuCategories(branchSlug)
				.then((payload) => {
					setCategories(payload);
				})
				.catch((feedback) => {
					openModal('message', { feedback });
				});
		}
	}, [isApplication, branchSlug, initialized]);

	useEffect(() => {
		if (isApplication && branchSlug) {
			submitMenuUrl(window.location.href).then(() => {
				redirect('menu');
			});
		}
	}, [branchSlug, isApplication]);

	return (
		<>
			<Loader full solid dark loading={isApplication} />
			{displayMenu ? (
				<>
					<WebMenuHeader className="product-header" backLink={false} title="Menü" />

					<div className="menu-container loader-container">
						<Loader dark loading={!categories} />
						{categories && (
							<div className="menu-categories wrapper">
								<strong className="categories-title">Kategoriler</strong>

								<ul className="categories-list">
									{categories.map((category) => (
										<li className="list-category" key={category.id}>
											<Link
												href="webMenuCategory"
												params={{ branchSlug, id: category.id }}
												className="category-link"
											>
												<div className="category-imagewrap">
													<Img src={category.image} className="category-image" />
												</div>
												<div className="category-textarea">
													<strong className="category-title">{category.title}</strong>
													{!!category.product_count &&
														<span className="category-count">{category.product_count} Ürün</span>
													}
												</div>
											</Link>
										</li>
									))}
								</ul>
							</div>
						)}
					</div>
				</>
			) : (
				<WebMenuLanding />
			)}
		</>
	);
};

export default WebMenu;
